import { ShieldCarIcon } from './ShieldCarIcon';

/**
 * author: Nick
 * id 2A7B43E0-4BA1-41EB-9040-F943AA9FD02C
 * name shield-car
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-car.svg
 * tags
 * - Automotive 
 */
export const CarSecurityIcon = ShieldCarIcon;
export default CarSecurityIcon